import { useEffect } from "react";
import DayDeals from "../components/Deals/DayDeals";
import MonthDeals from "../components/Deals/MonthDeals";
import WeekDeals from "../components/Deals/WeekDeals";
import Purchases from "../components/Products/Purchases";
import { useNavigate } from "react-router-dom";

const DealsMain = (props) => {
  const loadedContent = props.content;
  const navigate = useNavigate();

  useEffect(() => {
    if (loadedContent.redirect) {
      navigate(loadedContent.direction);
    }
  }, [loadedContent, navigate]);

  return (
    <>
      {loadedContent.day && <DayDeals products={loadedContent.day} />}
      {loadedContent.week && <WeekDeals products={loadedContent.week} />}
      {loadedContent.month && <MonthDeals products={loadedContent.month} />}
      {loadedContent.purchases && (
        <Purchases purchases={loadedContent.purchases} />
      )}
    </>
  );
};

export default DealsMain;
